<template>
  <Overlay v-if="node || imageUrl" @close="$emit('close')">
    <template v-if="node">
      <h3 class="is-3 mb-15">{{ node.label }}</h3>

      <h4 v-if="tableCaption" class="is-6 mb-5">{{ tableCaption }}</h4>

      <div v-if="tableRows.length" class="w-full overflow-x-auto">
        <div
          v-for="(row, i) in tableRows"
          :key="'row' + i"
          class="flex mb-5 w-full"
        >
          <span
            v-for="col in row"
            :key="col"
            class="flex-1 min-w-[12rem] py-10 px-15 text-center bg-gray/50 whitespace-nowrap"
            :class="i == 0 ? 'is-5' : ''"
          >
            {{ col }}
          </span>
        </div>
      </div>

      <div
        v-if="body || image"
        class="flex flex-col md:flex-row items-center -mx-10 mt-60 w-full lg:w-3/4 lg:mx-auto"
      >
        <div v-if="body" class="content md:w-2/3 px-10 w-full" v-html="body" />

        <MediaImage
          v-if="image"
          class="md:w-1/3 px-10"
          v-bind="image"
          style-name="product_teaser"
        />
      </div>
    </template>

    <template v-else>
      <img :src="imageUrl" />
    </template>
  </Overlay>
</template>

<script lang="ts" setup>
import type {
  MediaImageFragment,
  SizeguideViewNodeFragment,
} from '#build/graphql-operations'

const props = defineProps<{
  nodeId?: string
  imageUrl?: string
}>()

defineEmits(['close'])

const { data: node } = await useAsyncData<SizeguideViewNodeFragment | null>(
  () => {
    return props.nodeId
      ? useGraphqlQuery(
          'sizeguideView',
          { id: props.nodeId },
          {
            graphqlCaching: {
              client: true,
            },
          },
        ).then((v) =>
          v.data.entityById && 'image' in v.data.entityById
            ? v.data.entityById
            : null,
        )
      : Promise.resolve(null)
  },
)

const body = computed<string | undefined>(() => node.value?.body)
const image = computed<MediaImageFragment | undefined>(() => node.value?.image)
const tableRows = computed<string[][]>(() => node.value?.table?.rows || [])
const tableCaption = computed<string | undefined>(
  () => node.value?.table?.caption,
)
</script>
